import React, { useEffect, useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { debounce } from '@material-ui/core';
import { fetchOptions } from '../queries';
import FormInput from './FormInput';

const UniqueFormInput = ({ name, query, props, ...rest }) => {
    const {
        watch,
        formState: { dirtyFields },
        getValues,
        setError,
        clearErrors,
    } = useFormContext();

    const checkUniqueness = useCallback(
        debounce(async (value) => {
            // the `string()` wrapper prevents aqp from automatically casting to a number
            const where = { [query.uniqueKey || name]: `string(${value})` };
            const { endpoint, fields, useLoopback } = query;
            const existing = await fetchOptions({ endpoint, where, fields, useLoopback });
            if (existing.error) {
                setError(name, { type: 'unique', message: `Could not verify ${props.label}` });
            }
            if (existing.length) {
                setError(name, { type: 'unique', message: `${props.label} is not unique` });
            } else {
                clearErrors([name]);
            }
        }, 750),
        []
    );

    useEffect(() => {
        const [value] = getValues([name]);
        const dirty = dirtyFields[name];
        if (!!value && dirty) {
            checkUniqueness(value);
        }
    }, [...watch([name])]);

    return <FormInput name={name} props={props} />;
};

export default UniqueFormInput;
